import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from '../vqutils/vq-alert/vq-alert.component';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-space-step-9',
  templateUrl: './space-step-9.component.html',
  styles: []
})
export class SpaceStep9Component implements OnInit {

  space: any = {};
  errors: any = {};
  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private _as: AlertService,
    private _api: ApiService,
  ) { }

  ngOnInit() {
    // this._as.success('Vous ne pouvez définir qu\'un seul chef de projet');
    this.route.params.subscribe(
      params => {
        if (params['id']) {
          this.space.id = params['id'];
          this._api.spaces
            .retrieve(this.space.id)
            .subscribe(
              (data) => {
                this.space = data;
              },
              (errors) => {
              });
        }
      });
  }

  submit() {
    this.isLoading = true;
    if (this.space.id) {
      this._api.spaces
        .partialUpdate(this.space.id, { progress: this.space.progress })
        .subscribe(
          (data) => {
            this.space = data;
            this._as.success('L\'avancement a été mis à jour');
            this.isLoading = false;
          },
          (errors) => {
            this.errors = errors;
            this._as.danger('Des erreurs empêchent la mise à jour de l\'avancement');
            this.isLoading = false;
          });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/space-step-9/space-step-9.component.ts